import {LiveDashboard} from "@common/ui-components/live/live-dashboard/live-dashboard";
import collection from "./table-conditional-format-collection.json";
import data from "./table-conditional-format-data.json";

export const TableConditionalFormatThemeAuto = (props) => {
    return LiveDashboard({
        collection,
        defaultData: data,
        disabledTileActions: true,
        ...props,
    });
};
